import React, { useState } from 'react'

import { Button, Input, ModalBox } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import type { PostTag } from '../../types'
import { validationSchema } from './consts'
import type { FormValues } from './types'
import { FormFields } from './types'

type Props = {
  tag?: PostTag
  onSubmit: (values: FormValues) => Promise<any>
  onClose: () => void
}

export const PostTagModal = ({ tag, onSubmit, onClose }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const form = useFormik<FormValues>({
    initialValues: tag
      ? {
          [FormFields.text]: tag.name,
        }
      : {
          [FormFields.text]: '',
        },
    onSubmit: async (values) => {
      try {
        setIsLoading(true)
        await onSubmit(values)
        setIsLoading(false)
      } catch {
        setIsLoading(false)
      }
    },
    validationSchema,
    enableReinitialize: true,
  })

  return (
    <ModalBox
      title={tag ? 'Edit tag' : 'Create tag'}
      size="small"
      buttons={[
        <Button label="Cancel" type="button" appearance="secondary" onClick={onClose} />,
        <Button
          label={tag ? 'Save' : 'Create tag'}
          appearance="primary"
          onClick={form.submitForm}
          disabled={tag ? !form.dirty : false}
          loading={isLoading}
        />,
      ]}
      onClose={onClose}
    >
      <Input label="Tag name" {...form.getFieldProps(FormFields.text)} />
    </ModalBox>
  )
}
